import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    AlertBannerInlineWrapper,
    InfoIconWrapper,
} from 'src/domains/layouts/webview/components/alertBanner/Inline.style';

interface AlertBannerInlinePropsType {
    className?: string;
    dataTest?: string;
    marginBottom?: string;
    marginTop?: string;
    message: React.ReactNode;
    size: 'small' | 'medium';
}

export const AlertBannerInline = observer(
    'AlertBannerInline',
    ({
        dataTest,
        message,
        marginTop,
        marginBottom,
        className,
        size,
    }: AlertBannerInlinePropsType): JSX.Element | null => {
        if (message === null || message === undefined) {
            return null;
        }

        return (
            <AlertBannerInlineWrapper
                className={className}
                data-test={dataTest === undefined ? `alert-banner-inline-content` : dataTest}
                marginBottom={marginBottom}
                marginTop={marginTop}
                size={size}
            >
                <InfoIconWrapper />
                {message}
            </AlertBannerInlineWrapper>
        );
    }
);
